import { Autocomplete } from "stimulus-autocomplete";
export default class extends Autocomplete {
  /* Override Autocomplete method, so it won't load autocomplete results again when an address is selected */
  onInputFocus() {}

  /* override Autocomplete method to handle country */
  fetchResults() {
    const country = document.querySelector(
      "#account_address_AddressCountry"
    ).value;
    const query = this.inputTarget.value.trim();

    if (!query) {
      this.resultsTarget.hidden = true;
      return;
    }
    if (query.length < this.minLength) {
      this.resultsTarget.hidden = true;
      return;
    }

    if (country !== "Australia") {
      this.resultsTarget.hidden = true;
      return;
    }

    if (!this.src) return;

    const url = new URL(this.src, window.location.href);
    const params = new URLSearchParams(url.search.slice(1));
    params.append("q", query);
    params.append("country", country);
    url.search = params.toString();

    this.element.dispatchEvent(new CustomEvent("loadstart"));

    fetch(url.toString())
      .then(response => response.text())
      .then(html => {
        this.resultsTarget.innerHTML = html;
        this.identifyOptions();
        const hasResults =
          !!this.resultsTarget.querySelector('[role="option"]');
        this.resultsTarget.hidden = !hasResults;
        this.element.dispatchEvent(new CustomEvent("load"));
      })
      .catch(() => {
        this.element.dispatchEvent(new CustomEvent("error"));
      });
  }
}
